import {DepositRefundModel} from "./DepositRefundModel";

export class DepositRefundDetailModel extends DepositRefundModel {
    constructor(row = {}) {
        super(row);
        this.bankAccountNumber = row.bank_account_number ?? "";
        this.bankAccountName = row.bank_account_name ?? "";
        this.bankName = row.bank_name ?? "";
        this.note = row.note ?? "";
        this.refundReasonType = row.refund_reason_type ?? null;
        this.refundReasonLabel = row.refund_reason_label ?? "";
        this.absenceCount = row.absence_count ?? 0;
        this.homeworkMissingCount = row.homework_missing_count ?? 0;
        this.latestErrorUpdatedAt = DepositRefundDetailModel.formatDateTime(row.latest_error_updated_at);
        this.committedFeeAmount = row.committed_fee_amount ?? 200000;
        this.requestedAt = DepositRefundDetailModel.formatDateTime(row.requested_at);
        this.reviewedAt = DepositRefundDetailModel.formatDateTime(row.reviewed_at);
        this.accountingRejectReason = row.accounting_reject_reason ?? "";
        this.statusHistory = (row.status_history ?? []).map((log) => new DepositRefundStatusLogModel(log));
    }
}

export class DepositRefundStatusLogModel {
    constructor(row = {}) {
        this.id = row.id ?? null;
        this.actionLabel = row.action_label ?? "";
        this.note = row.note ?? "";
        this.refundReasonLabel = row.refund_reason_label ?? "";
        this.changedByName = row.changed_by_name ?? "";
        this.changedAt = DepositRefundDetailModel.formatDateTime(row.changed_at ?? row.created_at);
        this.toProcessingStatus = Number(row.to_processing_status ?? 0);
    }

    get title() {
        const actor = this.changedByName || "Hệ thống";
        return `${actor} đã ${this.actionLabel}`;
    }

    get showRefundReason() {
        return Boolean(this.refundReasonLabel) && this.toProcessingStatus === 2;
    }
}
